import React, { createContext, useContext, useEffect, useState } from "react";

const FavContext = createContext({ favorites: [], toggle: () => {}, isFav: () => false });

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    try {
      const raw = localStorage.getItem("ikh-favorites");
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("ikh-favorites", JSON.stringify(favorites));
  }, [favorites]);

  const toggle = (slug) => {
    setFavorites((f) => (f.includes(slug) ? f.filter((s) => s !== slug) : [...f, slug]));
  };
  const isFav = (slug) => favorites.includes(slug);

  return <FavContext.Provider value={{ favorites, toggle, isFav }}>{children}</FavContext.Provider>;
};

export const useFavorites = () => useContext(FavContext);
